export const DEFAULT_PLACEHOLDER = 'Open Graph Description';
export const DEFAULT_NAME = 'seoOgDescription';
export const DEFAULT_LABEL = 'Open Graph Description';

export const MIN_INPUT_LENGTH_WARNING = 60;
export const MAX_INPUT_LENGTH_WARNING = 160;

export const DEFAULT_HELP_TOOLTIP_MESSAGE = `Enter a brief, engaging description that will appear when your content is shared on social media. Aim for ${MIN_INPUT_LENGTH_WARNING}-${MAX_INPUT_LENGTH_WARNING} characters to ensure it looks great on platforms like Facebook and Twitter. If left empty, the default placeholder value is used.`;
